var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashMeter = function SvgDashMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M12 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12 15v-5M22 13c0-5.523-4.477-10-10-10S2 7.477 2 13"
  })));
};
export default SvgDashMeter;